// assets
import { Setting2 } from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

const AgencyLibrarySettings: NavItemType = {
  id: 'group-agency-library-settings',
  title: 'Agency library',
  type: 'group',
  visibleForUserTypes: ['assessorAdmin'],
  children: [
    {
      id: 'agency-library-sharing',
      title: 'Shared question bank & rubrics',
      type: 'item',
      url: '/agency-library-settings',
      icon: Setting2,
      breadcrumbs: false
    }
  ]
};

export default AgencyLibrarySettings;
